import * as React from "react";
import { PureComponent } from "react";
import { Portal, Backdrop, Card, CardContent, Fade } from "@material-ui/core";
import { withStyles, WithStyles, Theme } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import ContentCircularProgress, { ContentCircularProgressProps } from "./general/ContentCircularProgress";

interface CircularProgressBlanketOwnProps extends ContentCircularProgressProps, WithStyles<typeof styles> {
  fadeTime?: number;
}

class CircularProgressBlanket extends PureComponent<CircularProgressBlanketOwnProps> {
  render() {
    const { classes, fadeTime, ...other } = this.props;
    let fadeTimeout = 700;
    if (fadeTime) {
      fadeTimeout = fadeTime;
    }
    return (
      <Portal>
        <>
          <div className={classes.progressContainer}>
            {this.props.loadingText ? (
              <Fade in={true} timeout={fadeTimeout} {...({} as any)}>
                <Card className={classes.progress}>
                  <CardContent>
                    <ContentCircularProgress {...other} />
                  </CardContent>
                </Card>
              </Fade>
            ) : (
              <Fade in={true} timeout={fadeTimeout} {...({} as any)}>
                <ContentCircularProgress className={classes.progress} {...other} />
              </Fade>
            )}
          </div>
          <Fade in={true} timeout={fadeTimeout} {...({} as any)}>
            <Backdrop className={classes.backdrop} open={true} />
          </Fade>
        </>
      </Portal>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    progress: {
      zIndex: theme.zIndex.modal + 1,
      alignSelf: "center"
    },
    progressContainer: {
      display: "flex",
      justifyContent: "center",
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    backdrop: {
      zIndex: theme.zIndex.modal
    }
  });

export default withStyles(styles)(CircularProgressBlanket);
